/** @deprecated 以下の composables/useMetaPageTitles/index.ts に集約して、meta や breadcrumbs をまとめて管理したほうが見やすそう */
export const metaTitleFormat = (parentChunks: string | undefined, ...chunks: string[]) => [
  parentChunks,
  ...chunks,
].filter(Boolean).reverse().join(' ｜ ')
